/* eslint-disable-next-line */
export interface LAuthorCardProps {
  authorImage: {
    url: string;
    altTag: string;
  };
  onClick?: () => void;
  firstName?: string;
  lastName?: string;
  occupation?: string | undefined | null;
}

export function LAuthorCard(props: LAuthorCardProps) {
  return (
    <div
      className="w-full lg:w-[300px] flex-shrink-0 h-[250px] lg:h-[400px] rounded-lg overflow-hidden  bg-cover flex items-end justify-center cursor-pointer hover:scale-105 transition-all"
      style={{
        backgroundImage: `url('${props?.authorImage?.url}')`,
        backgroundPosition: "top center"
      }}
      onClick={props?.onClick}
    >
      <div className="w-full pt-8 pb-5 mt-auto text-center bg-gradient-to-b from-transparent to-black">
        <div className="text-lg font-bold text-white">{`${props?.firstName} ${props?.lastName}`}</div>
        <div className="text-white">{props?.occupation}</div>
      </div>
    </div>
  );
}

export default LAuthorCard;
